import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { App, message, Select } from 'antd';
import { APPOINTMENT_STATUS_VALUES } from 'constants/appointments';
import { updateAppointmentStatus } from 'services/api/appointments';
import { AppointmentStatus } from 'types/api/appointments';

import { useAppointmentDetail } from 'pages/AppointmentsDetails/AppointmentDetailContext';
import { showErrorMessage } from 'utils/showErrorMessage';

interface IProps {
  appointmentId: string;
  status: AppointmentStatus | null;
}

const StatusSelect: FC<IProps> = ({ appointmentId, status }) => {
  // translations
  const { t } = useTranslation();
  const { modal } = App.useApp();
  const { refresh } = useAppointmentDetail();
  const [loading, setLoading] = useState(false);

  const onChange = (value: AppointmentStatus) => {
    modal.confirm({
      title: 'Warning',
      content: (
        <p>
          Changing the status may potentially introduce some inconsistencies.
          Please take a moment to carefully review and confirm that everything
          is in order
        </p>
      ),
      okText: 'Yes',
      async onOk() {
        try {
          setLoading(true);
          await updateAppointmentStatus(appointmentId, value);
          message.success(t(`messages.successfully_updated`));
          refresh();
        } catch (err) {
          showErrorMessage(err);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  return (
    <Select
      style={{ width: 200 }}
      options={Object.entries(APPOINTMENT_STATUS_VALUES).map(
        ([value, label]) => ({
          label: t(`appointments.${label}`),
          value
        })
      )}
      value={status ?? undefined}
      loading={loading}
      onChange={onChange}
    />
  );
};

export default StatusSelect;
